import Mesh3D from './Mesh3D';
import { ShaderProgram } from '../rendering/Shader';
import Renderer from '../rendering/Renderer';

export default class Mesh3D_TRIANGLE_normal extends Mesh3D {

	constructor (geometry) {
		super(geometry);
	}

	createVertexBuffer (geometry) {
		const triangles = geometry.faces;
		const positions = geometry.positions;
		const normals = geometry.normals;

		const vertexSize  = 24;
		this.vertexCount = triangles.length * 3;

		// Populating vertex buffer
		this.vertexBuffer = new ArrayBuffer(this.vertexCount * vertexSize);
		const float32View  = new Float32Array(this.vertexBuffer);

		let index = 0;
		for (let t = 0; t < triangles.length; t++) {
			const triangle = triangles[t];
			const vertexIndexes = triangle.vertices;
			const normalIndexes = triangle.normals;

			const a = positions[vertexIndexes.x];
			const b = positions[vertexIndexes.y];
			const c = positions[vertexIndexes.z];

			const na = normals[normalIndexes.x];
			const nb = normals[normalIndexes.y];
			const nc = normals[normalIndexes.z];

			float32View[index + 0] = a.x;
			float32View[index + 1] = a.y;
			float32View[index + 2] = a.z;

			float32View[index + 3] = na.x;
			float32View[index + 4] = na.y;
			float32View[index + 5] = na.z;

			float32View[index + 6] = b.x;
			float32View[index + 7] = b.y;
			float32View[index + 8] = b.z;

			float32View[index + 9]  = nb.x;
			float32View[index + 10] = nb.y;
			float32View[index + 11] = nb.z;

			float32View[index + 12] = c.x;
			float32View[index + 13] = c.y;
			float32View[index + 14] = c.z;

			float32View[index + 15] = nc.x;
			float32View[index + 16] = nc.y;
			float32View[index + 17] = nc.z;

			index += 18;
		}

		// const vertexSize  = 24;
		// this.vertexCount = faces.length * 3;

		// // Populating vertex buffer
		// this.vertexBuffer = new ArrayBuffer(positions.length * vertexSize);
		// const float32View  = new Float32Array(this.vertexBuffer);

		// let index = 0;
		// for (let v = 0; v < positions.length; v += 1) {
		// 	const position = positions[v];
		// 	const normal   = normals[v]; // Same number of positions and normals

		// 	float32View[index]     = position.x;
		// 	float32View[index + 1] = position.y;
		// 	float32View[index + 2] = position.z;

		// 	float32View[index + 3] = normal.x;
		// 	float32View[index + 4] = normal.y;
		// 	float32View[index + 5] = normal.z;
		// 	index += 6;
		// }

		// // Populating index buffer
		// this.indexBuffer = new Uint16Array(faces.length * 3);
		// const vertexIndexBuffer = this.indexBuffer;
		// index = 0;
		// for (let f = 0; f < faces.length; f++) {
		// 	const face = faces[f];
		// 	vertexIndexBuffer[index]     = face.a;
		// 	vertexIndexBuffer[index + 1] = face.b;
		// 	vertexIndexBuffer[index + 2] = face.c;

		// 	index += 3;
		// }
	}

	render (renderer: Renderer, program: ShaderProgram, withNormals: boolean) {
		const gl = renderer.gl;
		const rendererID = renderer.id;

		let buffers = this.bufferBinders[rendererID];
		if (buffers === undefined) {
			buffers = this.uploadVertexBuffers(renderer);
		}

		gl.bindBuffer(gl.ARRAY_BUFFER, buffers.vertex);
		// gl.bindBuffer(gl.ELEMENT_ARRAY_BUFFER, buffers.index);

		const attributes = program.attributes;
		const bytesPerVertex = 4 * 3 + 4 * 3;
		gl.vertexAttribPointer(attributes.aVertexPosition, 3, gl.FLOAT, false, bytesPerVertex, 0);
		if (withNormals === true) {
			gl.vertexAttribPointer(attributes.aVertexNormal, 3, gl.FLOAT, true, bytesPerVertex, 4 * 3);
		}

		// gl.drawElements(gl.TRIANGLES, this.vertexCount, gl.UNSIGNED_SHORT, 0);
		gl.drawArrays(gl.TRIANGLES, 0, this.vertexCount);
		// debugger
	}

}
